const FETCH_TRADE_SUCCESS = 'TRADE_FETCHED_SUCCESSFULLY';
const FETCH_TRADE_IN_PROGRESS = 'FETCH_TRADE_IN_PROGRESS';
const SET_ENABLED_PROMOTIONS = 'header/SET_ENABLED_PROMOTIONS';
// todo(oscar): START HERE: trace down all uses of set_profile
const REQUEST_PROFILE = 'header/REQUEST_PROFILE';
const REQUEST_PROFILE_SUCCESS = 'header/REQUEST_PROFILE_SUCCESS';
const REQUEST_PROFILE_ERROR = 'header/REQUEST_PROFILE_ERROR';
// ============================================
const SET_FAVORITES = 'SET_FAVORITES';
const SET_ACCOUNT_URLS = 'SET_ACCOUNT_URLS';

const SET_GEOLOCATION = 'SET_GEOLOCATION';
const SET_APP_SETTINGS = 'SET_APP_SETTINGS';

// note(oscar): discounts.types.js
const GET_DISCOUNTS_LOADING = 'header/account/GET_DISCOUNTS/LOADING';
const GET_DISCOUNTS_SUCCESS = 'header/account/GET_DISCOUNTS/SUCCESS';
const GET_DISCOUNTS_ERROR = 'header/account/GET_DISCOUNTS/ERROR';
// ===================================

const SET_IS_IN_DOT_COM = 'header/root/SET_IS_IN_DOT_COM';

const SET_CAMPAIGN_PROMOTIONS = 'header/promotions/SET_CAMPAIGN_PROMOTIONS';

const FETCH_PURCHASE_SUMMARY_SUCCESS = 'PURCHASE_SUMMARY_FETCHED_SUCCESSFULLY';
const FETCH_PURCHASE_SUMMARY_IN_PROGRESS = 'FETCH_PURCHASE_SUMMARY_PROGRESS';

const FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_BEGIN = 'FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_BEGIN';
const FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_SUCCESS = 'FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_SUCCESS';
const FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_FAILURE = 'FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_FAILURE';

export {
  FETCH_TRADE_SUCCESS,
  FETCH_TRADE_IN_PROGRESS,
  SET_ENABLED_PROMOTIONS,
  FETCH_PURCHASE_SUMMARY_SUCCESS,
  FETCH_PURCHASE_SUMMARY_IN_PROGRESS,
  REQUEST_PROFILE,
  REQUEST_PROFILE_SUCCESS,
  REQUEST_PROFILE_ERROR,
  SET_FAVORITES,
  SET_ACCOUNT_URLS,
  SET_GEOLOCATION,
  SET_APP_SETTINGS,
  SET_IS_IN_DOT_COM,
  GET_DISCOUNTS_LOADING,
  GET_DISCOUNTS_SUCCESS,
  GET_DISCOUNTS_ERROR,
  SET_CAMPAIGN_PROMOTIONS,
  FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_BEGIN,
  FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_SUCCESS,
  FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_FAILURE
};
